var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-rating",on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.totalStars),function(star,index){return _c('div',{key:index,staticClass:"star-item",class:{
      'star-active': index < Math.floor(_vm.currentValue),
      'star-half':
        index === Math.floor(_vm.currentValue) && _vm.currentValue % 1 !== 0,
    },on:{"click":function($event){return _vm.handleStarClick(index + 1)},"mouseenter":function($event){return _vm.handleMouseEnter(index + 1)},"mouseleave":_vm.handleMouseLeave}},[_c('img',{staticClass:"star-img",attrs:{"src":_vm.getStarSrc(index),"alt":("star-" + index)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8527874c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StarRating/index.vue
// module id = pIAZ
// module chunks = 3